module.exports = __webpack_public_path__ + "img/class7.71d48d96.jpg";